import { render, staticRenderFns } from "./catalog-list-car.vue?vue&type=template&id=1db4e1ae&"
import script from "./catalog-list-car.vue?vue&type=script&lang=js&"
export * from "./catalog-list-car.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogItemMinicard: require('/var/www/components/catalog/catalog-item/catalog-item-minicard.vue').default})
